import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Room } from 'src/app/data/models/interfaces/room.interface';

@Component({
  selector: 'app-chat-forward-room',
  templateUrl: './chat-forward-room.component.html',
  styleUrls: ['./chat-forward-room.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatForwardRoomComponent {
  nameFilter: string | undefined = '';
  selected: Room | undefined;

  constructor(
    public dialogRef: MatDialogRef<ChatForwardRoomComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { rooms: Room[] }
  ) {}

  search(event: string) {
    this.nameFilter = event;
  }

  filterByName(room: Room, filter: string) {
    if (filter && filter !== '') {
      return room.name.toLowerCase().includes(filter.toLowerCase());
    } else {
      return true;
    }
  }

  select(room: Room) {
    this.selected = room;
  }
}
